import { EshapeColor, IBrandIcon } from '@spinwise/react-component-library/BrandIcon';
import {
  ECoreIconNames,
  ECoreNotificationDestinations,
  ECoreNotificationShapeColors,
  ECoreNotificationStatusIcons,
  ICoreIcon,
} from '@spinwise/spinwise-core';
import { PATHS } from '../libraries/routes.library';
import { EBrandIconStatusPathShared, EBrandIconStatusStrokeShared } from './icons';

export const mapCoreIconInterface = (el: ICoreIcon): Omit<IBrandIcon, 'iconSize'> => {
  let icon = `/images/notifications/bonus-notification.png`;
  try {
    const statusPath = mapCoreNotificationStatus(el.status);
    switch (el.iconName) {
      case ECoreIconNames.ACCOUNT_FLAT:
        icon = `/images/notifications/${ECoreIconNames.ACCOUNT_FLAT}.png`;
        break;
      case ECoreIconNames.BONUS_NOTIFICATION:
        icon = `/images/notifications/${ECoreIconNames.BONUS_NOTIFICATION}.png`;
        break;
      case ECoreIconNames.BONUS_VIP_NOTIFICATION:
        icon = `/images/notifications/${ECoreIconNames.BONUS_VIP_NOTIFICATION}.png`;
        break;
      case ECoreIconNames.CASHBACK_FLAT:
        icon = `/images/notifications/${ECoreIconNames.CASHBACK_FLAT}.png`;
        break;
      case ECoreIconNames.LOSS_LIMIT_FLAT:
        icon = `/images/notifications/${ECoreIconNames.LOSS_LIMIT_FLAT}.png`;
        break;
      case ECoreIconNames.MAIL_FLAT:
        icon = `/images/notifications/${ECoreIconNames.MAIL_FLAT}.png`;
        break;
      case ECoreIconNames.MAINTENANCE_FLAT:
        icon = `/images/notifications/${ECoreIconNames.MAINTENANCE_FLAT}.png`;
        break;
      case ECoreIconNames.NEW_GAME_FLAT:
        icon = `/images/notifications/${ECoreIconNames.NEW_GAME_FLAT}.png`;
        break;
      case ECoreIconNames.SOF_FLAT:
        icon = `/images/notifications/${ECoreIconNames.SOF_FLAT}.png`;
        break;
      case ECoreIconNames.SPORT_BONUS_NOTIFICATION:
        icon = `/images/notifications/${ECoreIconNames.SPORT_BONUS_NOTIFICATION}.png`;
        break;
      case ECoreIconNames.TOURNAMENT_FLAT:
        icon = `/images/notifications/${ECoreIconNames.TOURNAMENT_FLAT}.png`;
        break;
      case ECoreIconNames.BONUS_FS_NOTIFICATION:
        icon = `/images/notifications/${ECoreIconNames.BONUS_FS_NOTIFICATION}.png`;
        break;
      case ECoreIconNames.BONUS_MONEY_NOTIFICATION:
        icon = `/images/notifications/${ECoreIconNames.BONUS_MONEY_NOTIFICATION}.png`;
        break;
      case ECoreIconNames.BONUS_EXPIRED_NOTIFICATION:
        icon = `/images/notifications/${ECoreIconNames.BONUS_EXPIRED_NOTIFICATION}.png`;
        break;
      case ECoreIconNames.SPORT_BONUS_NOTIFICATION_MATCH:
        icon = `/images/notifications/${ECoreIconNames.SPORT_BONUS_NOTIFICATION_MATCH}.png`;
      case ECoreIconNames.RISK_FREE_BET_FLAT:
        icon = `/images/notifications/${ECoreIconNames.RISK_FREE_BET_FLAT}.png`;
        break;
      case ECoreIconNames.BONUS_WHEEL_SPIN_NOTIFICATION as any:
        icon = `/images/notifications/${ECoreIconNames.BONUS_WHEEL_SPIN_NOTIFICATION}.png`;
        break;
      case ECoreIconNames.LIVE_GAME_FREE_BET as any:
        icon = `/images/notifications/${ECoreIconNames.LIVE_GAME_FREE_BET}.png`;
        break;
    }
    return {
      iconPath: icon,
      statusPath: mapCoreNotificationStatus(el.status),
      statusStroke: LibraryBrandIconStatusStroke[statusPath] as EBrandIconStatusStrokeShared,
      shapeColor: mapCoreNotificationShapeColor(el.shape),
    };
  } catch (e) {
    return {
      iconPath: icon,
      statusPath: EBrandIconStatusPathShared.NONE,
      statusStroke: LibraryBrandIconStatusStroke[EBrandIconStatusStrokeShared.NONE] as EBrandIconStatusStrokeShared,
      shapeColor: mapCoreNotificationShapeColor(ECoreNotificationShapeColors.NOTIFICATION),
    };
  }
};
export const mapCoreNotificationShapeColor = (el: ECoreNotificationShapeColors): EshapeColor => {
  switch (el) {
    case ECoreNotificationShapeColors.NOTIFICATION:
      return EshapeColor.default;
    case ECoreNotificationShapeColors.SUCCESS:
      return EshapeColor.success;
    case ECoreNotificationShapeColors.WARNING:
      return EshapeColor.warning;
    default:
      return EshapeColor.none;
  }
};
export const mapCoreNotificationStatus = (el: ECoreNotificationStatusIcons): EBrandIconStatusPathShared => {
  switch (el) {
    case ECoreNotificationStatusIcons.NONE:
      return EBrandIconStatusPathShared.NONE;
    case ECoreNotificationStatusIcons.ATTENTION:
      return EBrandIconStatusPathShared.ATTENTION;
    case ECoreNotificationStatusIcons.FAILED:
      return EBrandIconStatusPathShared.FAILED;
    case ECoreNotificationStatusIcons.PENDING:
      return EBrandIconStatusPathShared.PENDING;
    case ECoreNotificationStatusIcons.SUCCESS:
      return EBrandIconStatusPathShared.SUCCESS;
    case ECoreNotificationStatusIcons.VERIFY:
      return EBrandIconStatusPathShared.VERIFY;
    case ECoreNotificationStatusIcons.WARNING:
      return EBrandIconStatusPathShared.WARNING;
  }
};
export const mapCoreNotificationDestination = (el: ECoreNotificationDestinations): string => {
  switch (el) {
    case ECoreNotificationDestinations.BONUSES:
      return PATHS.BONUSES;
    case ECoreNotificationDestinations.CONTACT:
      return PATHS.CONTACT_US;
    case ECoreNotificationDestinations.MY_ACCOUNT:
      return PATHS.ACCOUNT;
    case ECoreNotificationDestinations.SOF_FORM:
      return PATHS.ACCOUNT_SOFQ;
    case ECoreNotificationDestinations.SOF_UPLOAD:
      return PATHS.ACCOUNT_SOF;
    case ECoreNotificationDestinations.VERIFICATION_FORM:
      return PATHS.ACCOUNT_VERIFY;
    case ECoreNotificationDestinations.SOF_UPLOAD_SUBMITTED:
      return PATHS.ACCOUNT_SOF;
    case ECoreNotificationDestinations.VERIFICATION_PAGE:
      return PATHS.ACCOUNT_SOF;
    case ECoreNotificationDestinations.GAME_PAGE:
      return PATHS.GAMES;
    case ECoreNotificationDestinations.SPORTS:
      return PATHS.SPORTS;
    default:
      return '';
  }
};
export const LibraryBrandIconStatusStroke: {
  [k in EBrandIconStatusPathShared]: EBrandIconStatusStrokeShared;
} = {
  [EBrandIconStatusPathShared.NONE]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.ATTENTION]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.FAILED]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.PAUSE]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.PENDING]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.PLAY]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.PLUS]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.STOP]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.SUCCESS]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.UPDATE]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.VERIFY]: EBrandIconStatusStrokeShared.NONE,
  [EBrandIconStatusPathShared.WARNING]: EBrandIconStatusStrokeShared.NONE,
};
